import gematriya from "../../utils/gematriya"
import axios from "../../axios"
import { timeDiff } from "../../utils/util";
import { dimensions } from "./Common";
import { DateTime } from "luxon";

const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate()

const getFirstDay = (month, year) => new Date(year, month).getDay()

const getLastDay = (month, year) => new Date(year, month, getDaysInMonth(month, year)).getDay()

const getFirstDate = (month, year) => new Date(year, month, 1)

const getLastDate = (month, year) => new Date(year, month, getDaysInMonth(month, year))

const getStartEndTimes = (month, year, iso = true) => {
  let startOfMonth = getFirstDay(month, year)
  let startOfWeek = calculateDate(getFirstDate(month, year), startOfMonth, "sub")
  let endOfMonth = getLastDay(month, year)
  let endOfWeek = calculateDate(getLastDate(month, year), 6 - endOfMonth, "add")

  if (iso) {
    startOfWeek = startOfWeek.toISOString()
    endOfWeek = endOfWeek.toISOString()
  }

  return {start: startOfWeek, end: endOfWeek}
}

const getArrayOfDates = (start, end) => {
  let dates = []
  let currentDate = new Date(start)
  let endDate = new Date(end)

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate))
    currentDate.setDate(currentDate.getDate() + 1)
  }
  return dates
}

const getWeekRange = date => {
  const d = date?.day ? constructDate(date.day, date.month, date.year) : new Date(date);
  return {
    start: DateTime.fromJSDate(d).startOf('week', {useLocaleWeeks: true}).startOf('day').toJSDate(),
    end: DateTime.fromJSDate(d).endOf('week', {useLocaleWeeks: true}).startOf('day').toJSDate()
  };
};

const get3DayRange = date => {
  const d = date?.day ? constructDate(date.day, date.month, date.year) : new Date(date);
  return {
    start: DateTime.fromJSDate(d).startOf('day').toJSDate(),
    end: DateTime.fromJSDate(d).plus({days: 2}).endOf('day').toJSDate()
  };
}

const getStartOfWeek = date => {
  const d = date?.day ? constructDate(date.day, date.month, date.year) : new Date(date);
  return DateTime.fromJSDate(d).startOf('week').toJSDate();
}

const getDayOfWeekNames = (start, end) => {
  if (!start || !end) return ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  let days = []
  let currentDate = new Date(start)
  let endDate = new Date(end)
  while (currentDate <= endDate) {
    days.push(getWeekDay(currentDate, "long")?.toLowerCase())
    currentDate.setDate(currentDate.getDate() + 1)
  }
  return days
}

const calculateWeeks = (date, weeks, calc = "add") => {
  let startOfWeek = DateTime.fromJSDate(date).startOf('week', {useLocaleWeeks: true})
  if (calc === "add") {
    startOfWeek = startOfWeek.plus({weeks: weeks})
  } else {
    startOfWeek = startOfWeek.minus({weeks: weeks})
  }
  // console.log(startOfWeek.toLocaleString(), "startOfWeek after");
  return startOfWeek.startOf('day').toJSDate()
}

const calculateDate = (date, days, calc = "add") => {
  let newDate = new Date(date)
  if (calc === "add") {
    newDate.setDate(newDate.getDate() + days)
  } else {
    newDate.setDate(newDate.getDate() - days)
  }
  return newDate
}

const getDateParts = (date) => {
  if (date?.day && date?.day !== 0) {
    return date;
  } else {
    date = new Date(date)
    let day = date.getDate()
    let month = date.getMonth()
    let year = date.getFullYear()
    return {day, month, year}
  }
}

const ifanz = (val) => !val && val !== 0 // is false and not zero

const constructDate = (day, month, year) => {
  if (ifanz(day) || ifanz(month) || ifanz(year)) return new Date();
  return new Date(year, month, day)
}

const constructDateFromObj = ({day, month, year}) => new Date(year, month, day);

const dateToTz = (dateStr) => {
  const hasTz = dateStr.includes('T');
    if (hasTz) {
        // If it has time info, let Date constructor handle it
        return new Date(dateStr);
    } else {
        // If it's just YYYY-MM-DD, parse manually to avoid UTC interpretation
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
}

const calculateMonthAndYear = (month, year, calc = "add") => {
  let newMonth = month
  let newYear = year

  if (calc === "add") {
    newMonth = month + 1
    if (newMonth > 11) {
    // console.log(newMonth, "add")
      newMonth = 0
      newYear = year + 1
    }
  } else {
    newMonth = month - 1
    if (newMonth < 0) {
    // console.log(newMonth, "sub")
      newMonth = 11
      newYear = year - 1
    }
  }
  return {month: newMonth, year: newYear}
}

const findEventInDate = (event, date) => {
  // console.log(event, date, "findEventInDate!!!!!!!!!!!!!!!!!!!!");
  let eventDate = new Date(event.appointment_date)
  date = new Date(date)
  let startOfDay = DateTime.fromJSDate(date).startOf('day').toJSDate()
  let endOfDay = DateTime.fromJSDate(date).endOf('day').toJSDate()
  return eventDate >= startOfDay && eventDate <= endOfDay
}

/********** Hour Functions ************* */

const getYPos = (hour, height) => {
  // console.log(hour, "hour");
  return (hour) * (+height || dimensions.timeline.hour.height) * 10;
}

const roundMinutesToNearestPoint = (date, point = 15) => {
  let coeff = 1000 * 60 * point;
  let rounded = new Date(Math.round(date.getTime() / coeff) * coeff);
  // get percentage of the hour
  let minutes = rounded.getMinutes();
  let percentage = Math.round(minutes / 60 * 100);
  return percentage; 
}

function roundToPointOfHourTime(time, minOfHour = 15) {
  // Get the whole hours
  const hours = Math.floor(time);
  
  // Get decimal part and convert to minutes
  const minutes = (time - hours) * 60;
  
  // Round to nearest point, default is 15 minutes
  const roundedMinutes = Math.floor(minutes / minOfHour) * minOfHour;
  
  // Handle case where minutes round up to 60
  const finalHours = roundedMinutes === 60 ? hours + 1 : hours;
  const finalMinutes = roundedMinutes === 60 ? 0 : roundedMinutes;
  
  return {
    hours: finalHours,
    minutes: finalMinutes
  };
}

/**
 * Converts decimal hours to a HH:MM string with custom rounding.
 * @param {number} decimalTime - The time in decimal (e.g., 10.5)
 * @param {number} roundToMinutes - The minute interval to round to (e.g., 5, 10, 15)
 * @returns {string} - Formatted time string
 */
function convertDecimalToTime(decimalTime, roundToMinutes = 1, method = "round") {
  // 1. Convert decimal hours to total minutes
  let totalMinutes = Math.round(decimalTime * 60);

  // 2. Round to the nearest interval
  totalMinutes = Math.round(totalMinutes / roundToMinutes) * roundToMinutes;

  totalMinutes -= roundToMinutes; // bug fix for now

  // 3. Extract hours and remaining minutes
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;

  // Determine AM or PM
  const suffix = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  // (hours % 12) converts 13 to 1, 14 to 2, etc. 
  // || 12 ensures that 0 (midnight) or 12 (noon) shows as 12.
  hours = (hours % 12) || 12;

  // 4. Pad with leading zeros (e.g., 10:5 becomes 10:05)
  const paddedMinutes = minutes.toString().padStart(2, '0');
  
  return `${hours}:${paddedMinutes} ${suffix}`;
}


// get event length in hours and minutes
const getEventLength = (start, end) => {
  let startTime = new Date(start);
  let endTime = new Date(end);
  let diff = timeDiff(startTime, endTime);
  let minutes = diff.minutes ? diff.minutes / 60 : 0;
  return diff.hours + minutes;
}

// get event/block height based on start and end time
const getEventHeight = (start, end, height) => {
  let eventLength = getEventLength(start, end);
  return eventLength * +height * 10;
}

// get event top position based on start time
const getEventTopPos = (start, height, beginShow) => {
  let startTime = new Date(start);
  let curHour = startTime.getHours();
  let roundedTime = roundMinutesToNearestPoint(startTime, 1);
  let eventTop = getYPos((curHour + (roundedTime / 100) - beginShow), height);
  // console.log(eventTop, "eventTop")
  return eventTop;
}

/************************************ */

const calculateDays = (date, days, calc = "add") => {
  return calculateDate(date, days, calc).getDate()
}

const getToday = () => {
  let date = new Date()

  return {
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
  }
}


const parseTime = (timeString) => {
  if (!timeString) return 0;
  const [hours, minutes, seconds] = timeString.split(':').map(Number);
  return hours + minutes / 60 + seconds / 3600;
};


const getWeekDay = (date, format = "short") => {
  if (!date) return
  let weekday = daysObj[date.getDay()]
  return format === "short" ? weekday?.short : weekday.date
}

const getMonthName = (date, format = "short") => {
  if (!date) return
  let month = monthsObj[date.getMonth()]
  return format === "short" ? month?.short : month.month
}

const getHebFormattedDate = (date, str = false) => {
  let newDate = !str ? new Date(date).toISOString() : date;
  let getDate = newDate.split('T')[0]
  return getDate;
}

export const daysObj = [
  {
    date: "Sunday",
    short: "Sun"
  },
  {
    date: "Monday",
    short: "Mon"
  },
  {
    date: "Tuesday",
    short: "Tue"
  },
  {
    date: "Wednesday",
    short: "Wed"
  },
  {
    date: "Thursday",
    short: "Thu"
  },
  {
    date: "Friday",
    short: "Fri"
  },
  {
    date: "Saturday",
    short: "Sat"
  },
]

export const monthsObj = [
  {
    month: "January",
    short: "Jan"
  },
  {
    month: "February",
    short: "Feb"
  },
  {
    month: "March",
    short: "Mar"
  },
  {
    month: "April",
    short: "Apr"
  },
  {
    month: "May",
    short: "May"
  },
  {
    month: "June",
    short: "Jun"
  },
  {
    month: "July",
    short: "Jul"
  },
  {
    month: "August",
    short: "Aug"
  },
  {
    month: "September",
    short: "Sep"
  },
  {
    month: "October",
    short: "Oct"
  },
  {
    month: "November",
    short: "Nov"
  },
  {
    month: "December",
    short: "Dec"
  },
]

// en-u-ca-hebrew

const hebrewMonths = {
    "Tishri": "תשרי",
    "Heshvan": "חשון",
    "Kislev": "כסלו",
    "Tevet": "טבת",
    "Shevat": "שבט",
    "Adar": "אדר",
    "Adar II": "אדר ב'",
    "Nisan": "ניסן",
    "Iyar": "אייר",
    "Sivan": "סיון",
    "Tamuz": "תמוז",
    "Av": "אב",
    "Elul": "אלול"
}

const getHebrewDateParts = (date) => {
  let dateStr = date.split(',')[0]
  let [day, month, year] = dateStr.split(" ")

  return {day, month, year}
}

export const getHebrewMonthDate = (date) => {
  let {day, month, year} = getHebrewDateParts(date)

  // console.log({day, month, year});
  return `${gematriya(+day)} ${hebrewMonths[month]}`
  // return "hello"
}




export {
  getDaysInMonth,
  getFirstDay,
  calculateDays,
  getFirstDate,
  getToday,
  getStartEndTimes,
  getWeekRange,
  get3DayRange,
  dateToTz,
  getStartOfWeek,
  calculateWeeks,
  calculateDate,
  getArrayOfDates,
  getHebFormattedDate,
  calculateMonthAndYear,
  getYPos,
  roundMinutesToNearestPoint,
  convertDecimalToTime,
  getEventLength,
  getEventHeight,
  getEventTopPos,
  parseTime,
  roundToPointOfHourTime,
  getDateParts,
  constructDate,
  constructDateFromObj,
  getWeekDay,
  getMonthName,
  findEventInDate,
  getDayOfWeekNames

}
